// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class ExternalScreenStorage {
    constructor() {
        this._storage = {};
        this._storageByID = {};
        this.screensDisabled = false;
    }
    generateKey(name, tb) {
        return name + '+++' + tb;
    }
    Clear() {
        this._storage = {};
        this._storageByID = {};
    }
    GetToolData(id) {
        const it = this._storageByID[id];
        if (!it) {
            return null;
        }
        const tool = it.tool;
        return {
            Tool: tool,
            Text: tool.urlStr,
            ScreenName: tool.name,
            Aliases: tool.aliases,
            ClientTab: tool.clientTab,
            ClientUseInternalBrowser: tool.clientUseInternalBrowser
        };
    }
    GetTool(name, clientTab) {
        const key = this.generateKey(name, clientTab);
        const it = this._storage[key];
        if (!it) {
            return null;
        }
        const tool = it.tool;
        return tool;
    }
    AddItem(tool) {
        const toolById = this._storageByID[tool.id];
        const key = this.generateKey(tool.name, tool.clientTab);
        if (!toolById) {
            const it = {};
            it.scrArray = [];
            it.url = tool.urlStr;
            it.tool = tool;
            this._storage[key] = this._storageByID[tool.id] = it;
            return;
        }
        this.UpdateLinkItem(tool);
    }
    AddScreenItem(tool, scr) {
        const toolById = this._storageByID[tool.id];
        if (!toolById) {
            this.AddItem(tool);
        }
        toolById.scrArray.push(scr);
    }
    UpdateLinkItem(tool) {
        const it = this._storageByID[tool.id];
        if (!it) {
            return;
        }
        const arr = it.scrArray;
        const newarr = [];
        arr.forEach((scr) => {
            if (!scr.torndown) {
                scr.UpdateLink(tool.urlStr, tool.IsNoneLink(), tool);
                newarr.push(scr);
            }
        });
        it.scrArray = newarr;
        it.url = tool.urlStr;
        it.tool = tool;
    }
    DeleteItem(link) {
        var _a;
        const key = this.generateKey(link.name, link.clientTab);
        const item = this._storageByID[link.id];
        if (item) {
            const scrArr = item.scrArray;
            for (let i = 0; i < scrArr.length; i++) {
                const scr = scrArr[i];
                scr.close();
                (_a = scr.PanelContainer) === null || _a === void 0 ? void 0 : _a.onCloseButtonClicked();
            }
            item.scrArray = [];
            delete this._storageByID[link.id];
            if (this._storage[key]) {
                delete this._storage[key];
            }
        }
    }
    DisableAllScreens() {
        if (this.screensDisabled) {
            return;
        }
        this.changeAllScreensPointerEvents(true);
    }
    EnableAllScreens() {
        if (!this.screensDisabled) {
            return;
        }
        this.changeAllScreensPointerEvents(false);
    }
    changeAllScreensPointerEvents(disabling) {
        const toolsById = Object.values(this._storageByID);
        toolsById.forEach((t) => {
            const scrArr = t.scrArray;
            if (scrArr != null) {
                scrArr.forEach((scr) => {
                    if (scr.rendered === true) {
                        const iframe = scr.find('iframe');
                        if (iframe != null) {
                            iframe.style.pointerEvents = disabling ? 'none' : 'all';
                        }
                    }
                });
            }
        });
        this.screensDisabled = disabling;
    }
    applyThemeToAllScreens() {
        Object.values(this._storageByID).forEach((t) => {
            var _a;
            (_a = t.scrArray) === null || _a === void 0 ? void 0 : _a.forEach((scr) => { var _a; return (_a = scr === null || scr === void 0 ? void 0 : scr.applyTheme) === null || _a === void 0 ? void 0 : _a.call(scr); });
        });
    }
}
